import React from "react";
import {
    IResourceComponentsProps,
    BaseRecord,
    useTranslate,
} from "@refinedev/core";
import {
    useTable,
    List,
    EditButton,
    ShowButton,
    DeleteButton,
} from "@refinedev/antd";
import { Table, Space, Tag } from "antd";

export const FormList: React.FC<IResourceComponentsProps> = () => {
    const translate = useTranslate();
    const { tableProps } = useTable({
        syncWithLocation: true,
    });

    return (
        <List>
            <Table {...tableProps} rowKey="id">
                <Table.Column
                    dataIndex="id"
                    title={translate("forms.fields.id")}
                />
                <Table.Column
                    dataIndex="name"
                    title={translate("forms.fields.name")}
                />
                <Table.Column
                    dataIndex="isDefault"
                    title={translate("forms.fields.isDefault")}
                    render={(value: boolean) => (
                        <Tag color={value ? "green" : "default"}>
                            {value ? translate("titles.yes") : translate("titles.no")}
                        </Tag>
                    )}
                />
                <Table.Column
                    title={translate("table.actions")}
                    dataIndex="actions"
                    render={(_, record: BaseRecord) => (
                        <Space>
                            <EditButton
                                hideText
                                size="small"
                                recordItemId={record.id}
                            />
                            <ShowButton
                                hideText
                                size="small"
                                recordItemId={record.id}
                            />
                            <DeleteButton
                                hideText
                                size="small"
                                recordItemId={record.id}
                                hidden
                            />
                        </Space>
                    )}
                />
            </Table>
        </List>
    );
};
